module.exports = __webpack_public_path__ + "img/login_font.c454a417.png";